import { Controller, useFormContext } from "react-hook-form";
import Input from "../ui/input/Input";
import Select from "../ui/select/Select";
import { IServiceFeeFormValues } from "../../interfaces/endpoints/IServiceFee";
import { OperatorsSelectList } from "../../interfaces/endpoints/IOperators";
import { getAllCities } from "../../services/Locations.service";
import { getAllSelectOperators } from "../../services/Operators.service";

const emptyOperator: OperatorsSelectList = {
  id: 0,
  operatorName: "Të gjithë operatorët (pa specifikim)"
};

const ServiceFeeFormFields: React.FC<{ editMode?: boolean }> = ({
  editMode
}) => {
  const {
    control,
    register,
    formState: { errors }
  } = useFormContext<IServiceFeeFormValues>();

  return (
    <>
      <div className="mb-6">
        <Controller
          control={control}
          name="departureCity"
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <Select
              label="Qyteti i nisjes*"
              placeholder="Zgjedh qytetin e nisjes"
              onSelectedItemChange={(item) => onChange(item)}
              selectedItem={value}
              getOptionLabel={(o) => o.locationName}
              getOptionValue={(o) => o?.id}
              itemToString={(o) => o?.locationName || ""}
              asyncFunc={getAllCities}
              error={error?.message}
              disabled={editMode}
            />
          )}
        />
      </div>

      <div className="mb-6">
        <Controller
          control={control}
          name="arrivalCity"
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <Select
              label="Qyteti i mbërritjes*"
              placeholder="Zgjedh qytetin e mbërritjes"
              onSelectedItemChange={(item) => onChange(item)}
              selectedItem={value}
              getOptionLabel={(o) => o.locationName}
              getOptionValue={(o) => o?.id}
              itemToString={(o) => o?.locationName || ""}
              asyncFunc={getAllCities}
              error={error?.message}
              disabled={editMode}
            />
          )}
        />
      </div>

      <div className="mb-6">
        <Controller
          control={control}
          name="operator"
          render={({ field: { value, onChange } }) => (
            <Select
              label="Operatori (opsionale)"
              placeholder="Zgjedh operatorin"
              onSelectedItemChange={(item) => onChange(item)}
              selectedItem={value}
              emptyItem={emptyOperator}
              getOptionLabel={(o) => o.operatorName}
              getOptionValue={(o) => o?.id}
              itemToString={(o) => o?.operatorName || ""}
              asyncFunc={getAllSelectOperators}
            />
          )}
        />
        <p className="text-xs text-gray-500 mt-1">
          Lëre bosh për të aplikuar tarifën për të gjithë operatorët në këtë
          linjë.
        </p>
      </div>

      <div className="mb-6">
        <Input
          {...register("percentage")}
          label="Përqindja e tarifës (%)*"
          placeholder="p.sh. 15"
          error={errors?.percentage?.message}
          type="number"
          step="0.01"
        />
        <p className="text-xs text-gray-500 mt-1">
          Vendos përqindjen si numër (p.sh. 15 për 15%). Vlera default e
          backend-it është 10%.
        </p>
      </div>

      {!editMode && (
        <div className="mb-6">
          <label className="flex items-center">
            <input
              type="checkbox"
              {...register("applyBothDirections")}
              className="mr-2 w-4 h-4"
            />
            <span className="text-sm font-medium">
              Apliko në të dyja drejtimet
            </span>
          </label>
          <p className="text-xs text-gray-500 mt-1">
            Krijon automatikisht edhe konfigurimin e kundërt (p.sh. Tiranë →
            Prishtinë dhe Prishtinë → Tiranë).
          </p>
        </div>
      )}
    </>
  );
};

export default ServiceFeeFormFields;
